import { useTranslation } from "react-i18next";
import { FormInput } from "@/shared/Components";
import { FieldLayout } from "@/pages/ContactsPage/Components/FieldLayout";
import type { FC } from "react";
import type { FieldProps } from "@/pages/ContactsPage/types";

export const LinkField: FC<FieldProps> = ({ index }) => {
  const { t } = useTranslation();

  return (
    <FieldLayout>
      <FormInput
        name={`websites.${index}.websiteType.name`}
        placeholder={t("contactsPage.generalInfo.type")}
      />
      <FormInput name={`websites.${index}.websiteAddress`} placeholder="website.com" />
    </FieldLayout>
  );
};
